// extracted by mini-css-extract-plugin
module.exports = {"button":"e2ff468f85--button--DlbmS","button-text":"e2ff468f85--button-text--iZQnu","content":"e2ff468f85--content--loTMN"};